(function () {
  const DESKTOP_MQ = window.matchMedia('(min-width: 990px)');
  const EXPAND_TRANSITION_MS = 460;

  function ensureHiRes(img) {
    const hiSrc = img.dataset.srcHi;
    if (!hiSrc || img.dataset.hiLoaded === 'true') return;

    const loader = new Image();
    loader.onload = () => {
      img.src = hiSrc;
      img.dataset.hiLoaded = 'true';
    };
    loader.src = hiSrc;
  }

  function restoreStandardRes(img) {
    const stdSrc = img.dataset.srcStd;
    if (stdSrc && img.src !== stdSrc) {
      img.src = stdSrc;
      delete img.dataset.hiLoaded;
    }
  }

  function scrollToFigure(figure) {
    const top = figure.getBoundingClientRect().top + window.scrollY;
    window.scrollTo({ top, left: 0, behavior: 'instant' });
  }

  function afterLayout(callback) {
    requestAnimationFrame(() => requestAnimationFrame(callback));
  }

  function snapScroll(shop, figure, afterScroll) {
    shop.classList.add('llaves-shop--no-transition');
    afterLayout(() => {
      scrollToFigure(figure);
      afterLayout(() => {
        shop.classList.remove('llaves-shop--no-transition');
        if (afterScroll) afterScroll();
      });
    });
  }

  function scrollAfterTransition(shop, figure) {
    const imagesCol = shop.querySelector('.llaves-shop__images');
    if (!imagesCol) {
      afterLayout(() => scrollToFigure(figure));
      return;
    }

    let done = false;
    const finish = () => {
      if (done) return;
      done = true;
      imagesCol.removeEventListener('transitionend', onEnd);
      scrollToFigure(figure);
    };

    const onEnd = (event) => {
      if (event.target === imagesCol) finish();
    };

    imagesCol.addEventListener('transitionend', onEnd);
    setTimeout(finish, EXPAND_TRANSITION_MS + 50);
  }

  function setupHiResObserver(shop) {
    shop._hiResObserver?.disconnect();

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const img = entry.target.querySelector('img');
          if (img) ensureHiRes(img);
        });
      },
      { root: null, rootMargin: '50% 0px', threshold: 0 }
    );

    shop.querySelectorAll('.llaves-shop__figure').forEach((fig) => observer.observe(fig));
    shop._hiResObserver = observer;
  }

  function setExpanded(shop, expanded, figure) {
    if (!expanded) {
      const figureToRestore = figure || shop.querySelector('.llaves-shop__figure.is-active');

      shop.classList.remove('is-images-expanded');
      shop.setAttribute('aria-expanded', 'false');

      shop.querySelectorAll('.llaves-shop__figure.is-active').forEach((el) => {
        el.classList.remove('is-active');
      });

      shop._hiResObserver?.disconnect();
      shop._hiResObserver = null;

      if (figureToRestore) {
        snapScroll(shop, figureToRestore, () => {
          shop.querySelectorAll('.llaves-shop__figure img').forEach(restoreStandardRes);
        });
      } else {
        shop.querySelectorAll('.llaves-shop__figure img').forEach(restoreStandardRes);
      }
      return;
    }

    shop.classList.add('is-images-expanded');
    shop.setAttribute('aria-expanded', 'true');

    shop.querySelectorAll('.llaves-shop__figure.is-active').forEach((el) => {
      el.classList.remove('is-active');
    });

    if (!figure) return;

    figure.classList.add('is-active');
    scrollAfterTransition(shop, figure);

    const img = figure.querySelector('img');
    if (img) ensureHiRes(img);
    setupHiResObserver(shop);
  }

  function initShop(shop) {
    if (shop.dataset.llavesExpandInit) return;
    shop.dataset.llavesExpandInit = 'true';

    const imagesCol = shop.querySelector('.llaves-shop__images');
    if (!imagesCol) return;

    imagesCol.addEventListener('click', (event) => {
      if (!DESKTOP_MQ.matches) return;

      const figure = event.target.closest('.llaves-shop__figure');
      if (!figure) return;

      event.preventDefault();

      if (shop.classList.contains('is-images-expanded')) {
        setExpanded(shop, false);
      } else {
        setExpanded(shop, true, figure);
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && shop.classList.contains('is-images-expanded')) {
        setExpanded(shop, false);
      }
    });
  }

  function initAll() {
    document.querySelectorAll('.llaves-shop').forEach(initShop);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const shop = event.target.querySelector('.llaves-shop');
    if (shop) initShop(shop);
  });
})();
